import {
  EEstimationTargets,
  ETargetPage,
  MainFiltersWidget,
  resetFilters,
  setEstimationTarget,
} from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePushToggleController } from './utils/usePushToggleController';
import { setValuationFiltersModalOpened } from '../../actions/page';
import { ValuationFiltersMobileModal } from '../../components/ValuationFilters';
import { selectIsValuationFiltersModalOpened, selectIsWebview } from '../../selectors/page';
import { ValuationNotFoundContainer } from '../ValuationNotFoundContainer';
import { ValuationReadyContainer } from '../ValuationReadyContainer';
import { ValuationSubmitMobileContainer } from '../ValuationSubmitContainer';

export function ValuationFiltersMobileContainer() {
  const isWebview = useSelector(selectIsWebview);
  const isModalOpened = useSelector(selectIsValuationFiltersModalOpened);
  const dispatch = useDispatch();
  const { pushEnabled, handlePushToggle, isPushVisible } = usePushToggleController();

  const onCloseHandler = React.useCallback(() => {
    dispatch(resetFilters());
    dispatch(setEstimationTarget({ estimationTarget: EEstimationTargets.flat }));
    dispatch(setValuationFiltersModalOpened(false));
  }, [dispatch]);

  return (
    <ValuationFiltersMobileModal
      mainFiltersWidget={<MainFiltersWidget isWebview={isWebview} targetPage={ETargetPage.valuation} isEmbedded />}
      valuationFiltersSubmit={<ValuationSubmitMobileContainer />}
      valuationReady={<ValuationReadyContainer />}
      valuationNotFound={<ValuationNotFoundContainer />}
      onClose={onCloseHandler}
      isOpened={isModalOpened}
      pushValue={pushEnabled}
      onPushToggle={handlePushToggle}
      showPushToggle={isPushVisible}
    />
  );
}
